// noinspection SillyAssignmentJS,UnnecessaryLocalVariableJS

import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Card from "@material-tailwind/react/Card";
import CardBody from "@material-tailwind/react/CardBody";
import { BiArrowBack } from "react-icons/bi";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Loading from "../../../components/loading/Loading";
import Select from "react-select";
import {
  getMinRoom,
  roomSelector,
} from "../../../features/master/room/roomSlice";
import {
  addJobRequestTransaksiSelector,
  changeResponseSucess,
  getJobRequestDetailActivity,
} from "../../hrd/transaksi/job-request/AddjobRequestTransaksiSlice";
import {
  getMinKendaraan,
  kendaraanSelector,
} from "../../master/kendaraan/kendaraanSlice";
import { getMinOum, OumSelector } from "../../master/oum/oumSlice";

import moment from "moment";
import { getMinJetty, jettySelector } from "../../master/jetty/jettySlice";

import { Colors } from "../../../assets/Colors";
import {
  getMinKemasan,
  kemasanSelector,
} from "../../master/kemasan/kemasanSlice";
import { getMinLabour, labourSelector } from "../../master/labour/labourSlice";
import {
  getQuatationOperasional,
  quatationOperasionalSelector,
} from "../quatation/quatationOperasionalSlice";
import {
  getMinLimbah,
  limbahSelector,
} from "../../../features/master/limbah/limbahSlice";
import {
  getMinTypeOfClothing,
  typeOfClothingSelector,
} from "../../master/type-of-clothing/typeOfClothingSlice";
import { getMinGudang, gudangSelector } from "../../master/gudang/gudangSlice";
import { fuelSelector, getMinFuel } from "../../master/fuel/fuelSlice";
import ModalHeader from "@material-tailwind/react/ModalHeader";
import ModalFooter from "@material-tailwind/react/ModalFooter";
import Button from "@material-tailwind/react/Button";
import { Modal, ModalBody } from "@material-tailwind/react";
import {
  distentionSelector,
  getMinDistention,
} from "../../master/distention/distentionSlice";
import {
  aksiApproval,
  approvalSelector,
  reConfirm,
} from "../../setup/approval/approvalSlice";

import {
  jobRequestTransaksiSelector,
  KirimActivityClient,
} from "../../hrd/transaksi/job-request/jobRequestTransaksiSlice";
import { filterObjectViewer, objectDrawer } from "./OperationalOutputCommon";

function isRequired(value) {
  let status = false;
  if (value !== null) {
    if (typeof value === "number") {
      if (value !== -1) {
        status = true;
      }
    }
  }
  return status;
}

function useForm(initialState = {}, validations = [], onSubmit = () => {}) {
  const { isValid: initialIsValid, errors: initialErrors } = validate(
    validations,
    initialState,
  );
  const [changed, setChanged] = useState(false);
  const [values, setValues] = useState(initialState);
  const [errors, setErrors] = useState(initialErrors);
  const [isValid, setValid] = useState(initialIsValid);
  const [touched, setTouched] = useState({});

  const changeHandler = (event) => {
    const newValues = { ...values, [event.target.name]: event.target.value };
    const { isValid, errors } = validate(validations, newValues);
    setChanged(true);
    setValues(newValues);
    setValid(isValid);
    setErrors(errors);
    setTouched({ ...touched, [event.target.name]: true });
  };

  const changeHandlerCargodoring = (event, dex, subdex, i) => {
    let tempdata = JSON.parse(JSON.stringify(values.Activity));
    if (subdex === -1) {
      tempdata[dex].Detail[i][event.target.name] = event.target.value;
      changeHandlerActivity(tempdata);
    } else {
      if (tempdata) {
        tempdata[dex].DetailActivity[subdex]["Detail"][i][event.target.name] =
          event.target.value;
        tempdata[dex].DetailActivity[subdex]["Detail"][i]["Total"] =
          tempdata[dex].DetailActivity[subdex]["Detail"][i]["Unloading"];
        changeHandlerActivity(tempdata);
      }
    }
  };

  const changeHandlerTimeoum = (name, value, dex, subdex, i) => {
    let tempdata = JSON.parse(JSON.stringify(values.Activity));
    if (subdex === -1) {
      tempdata[dex].Detail[i][name] = value;
      changeHandlerActivity(tempdata);
    } else {
      if (tempdata) {
        tempdata[dex].DetailActivity[subdex]["Detail"][i][name] = value;
        changeHandlerActivity(tempdata);
      }
    }
  };

  const changeHandlerActivity = (data) => {
    const newValues = { ...values, Activity: data };
    const { isValid, errors } = validate(validations, newValues);
    setChanged(true);
    setValues(newValues);
    setValid(isValid);
    setErrors(errors);
  };

  const editHandler = (initValues) => {
    const newValues = {
      ...values,
      NamaKlien: initValues.NamaKlien,
      PermitToWork: initValues.PermitToWork,
      ShippingManifest: initValues.ShippingManifest,
      ShippingManifestDetail: initValues.ShippingManifestDetail,
      QuatationNo: initValues.QuatationNo,
      SPKNo: initValues.SPKNo,
      KlienID: initValues.KlienID,
      Priority: initValues.Priority,
      StatusKet: initValues.StatusKet,
      Activity: initValues.Activity,
      Status: initValues.Status,
      TrucksEntry: initValues.TrucksEntry,
      Labour: initValues.Labour,
      Equipment: initValues.Equipment,
      RequestUnit: initValues.RequestUnit,
    };
    setValues(newValues);
  };

  const editDetail = (value) => {
    const newValues = {
      ...values,
      Activity: value.Activity,
    };
    setValues(newValues);
  };

  const editEquipment = (value) => {
    const newValues = {
      ...values,
      Equipment: value,
    };
    setValues(newValues);
  };

  const editLabour = (value) => {
    const newValues = {
      ...values,
      Labour: value,
    };
    setValues(newValues);
  };

  const editTrucksEntry = (value) => {
    const newValues = {
      ...values,
      TrucksEntry: value,
    };
    setValues(newValues);
  };

  const clearHandler = () => {
    setValues(initialState);
  };

  const submitHandler = (event) => {
    event.preventDefault();
    onSubmit(values);
  };
  return {
    values,
    editTrucksEntry,
    changeHandlerCargodoring,
    changeHandler,
    editHandler,
    changeHandlerTimeoum,
    editDetail,
    clearHandler,
    isValid,
    errors,
    editEquipment,
    touched,
    submitHandler,
    editLabour,
    changeHandlerActivity,
  };
}

function validate(validations, values) {
  const errors = validations
    .map((validation) => validation(values))
    .filter((validation) => typeof validation === "object");
  return {
    isValid: errors.length === 0,
    errors: errors.reduce((errors, error) => ({ ...errors, ...error }), {}),
  };
}

const OperationalOutputDetail = ({}) => {
  const [berthingActivity, setBerthingActivity] = useState({});

  const jobRequest = useSelector(addJobRequestTransaksiSelector);
  const kendaraan = useSelector(kendaraanSelector);
  const jetty = useSelector(jettySelector);
  const oum = useSelector(OumSelector);
  const kemasan = useSelector(kemasanSelector);
  const labour = useSelector(labourSelector);
  const room = useSelector(roomSelector);
  const quatation = useSelector(quatationOperasionalSelector);
  const typeOfCloth = useSelector(typeOfClothingSelector);
  const locationUsed = useSelector(gudangSelector);

  const equipment = useSelector(kendaraanSelector);
  const feul = useSelector(fuelSelector);
  const distention = useSelector(distentionSelector);
  const approval = useSelector(approvalSelector);
  const approvalClient = useSelector(jobRequestTransaksiSelector);

  let initialState = {
    PermitToWork: "",
    Status: "",
    QuatationNo: "",
    SPKNo: "",
    Priority: "",
    KlienID: "",
    StatusKet: "",
    Activity: [],
  };

  const param = useLocation();

  const validations = [
    ({ QuatationNo }) =>
      isRequired(QuatationNo) || { QuatationNo: "Nomor Quatation wajib diisi" },
    ({ SPKNo }) => isRequired(SPKNo) || { SPKNo: "Nomor SPK wajib diisi" },
    ({ Priority }) =>
      isRequired(Priority) || { Priority: "Priority wajib diisi" },
    ({ KlienID }) => isRequired(KlienID) || { KlienID: "ID Klien wajib diisi" },
  ];

  const {
    values,
    errors,
    touched,
    changeHandler,
    editHandler,
    changeHandlerTimeoum,
    editEquipment,
    editDetail,
    editLabour,
    changeHandlerCargodoring,
    editTrucksEntry,
    changeHandlerActivity,
  } = useForm(initialState, validations);

  const [buttonTouched, setButtonTouched] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [Tanggal, setTanggal] = useState("");
  const [TanggalIncoming, setTanggalIncoming] = useState("");
  const [isValidTanggal, setIsValidTanggal] = useState(true);
  const [isValidTanggalIncoming, setIsValidTanggalIncoming] = useState(true);
  const [firstLoading, setFirstLoading] = useState(false);
  const [approvalLoading, setApprovalLoading] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [selector, setSelector] = useState([]);
  const [selectorRoom, setSelectorRoom] = useState([]);
  const limbah = useSelector(limbahSelector);
  const [selectorLimbah, setSelectorLimbah] = useState([]);
  const [selectorLimbah2, setSelectorLimbah2] = useState([]);
  const [selectorLocationUsed, setSelectorLocationUsed] = useState([]);
  const [selectorEquipment, setSelectorEquipment] = useState([]);
  const [selectorLabour, setSelectorLabour] = useState([]);
  const [selectorTrucks, setSelectorTrucks] = useState([]);
  const [checkedState, setCheckedState] = useState(false);
  const [modalShippingManifest, setModalShippingManifest] = useState(false);
  const [materialSupply, setMaterialSupply] = useState([]);

  const Kelompok = [
    { value: "1", label: "Heavy Equipment" },
    { value: "2", label: "Lifting Rigging Equipment" },
    { value: "3", label: "Cargo Carrying Unit" },
  ];
  const detailSevendoring = {
    Material: "",
    Package: "",
    Loading: "",
    Unloading: "",
    Remarks: "",
    Total: "",
    UomGeneral: "",
    UomLoading: "",
    UomUnloading: "",
    StartTime: "",
    EndTime: "",
  };

  const detailServices = {
    form1: "",
    form2: "",
    form3: "",
    form4: "",
    form5: "",
    form6: "",
    form7: "",
    form8: "",
    form9: "",
    UoM: "",
    date1: new Date(),
    date2: new Date(),
  };

  const detailVeselBerhing = {
    FinishTime: new Date(),
    FinishTimeSub: new Date(),
    Remaks: "",
    Remaksbot: "",
    StartTime: new Date(),
    StartTimeSub: new Date(),
    TotalHour: "",
    Manifest: "",
    Jetty: "",
  };

  function handleInsertJR() {
    if (!jobRequest.dataDetail?.JRID) {
      alert("⚠️ Data JR tidak tersedia");
      return;
    }

    setApprovalLoading(true);

    const action = param.state?.isClient
      ? KirimActivityClient({ JRID: jobRequest.dataDetail.JRID })
      : aksiApproval({
          TransaksiApprovalID: jobRequest.dataDetail.JRID,
          Status: "",
          Revisi: "",
        });

    dispatch(action)
      .unwrap()
      .then(() => {
        alert("✅ Approval berhasil");
        if (param.state?.isClient) {
          navigate("/");
        } else {
          navigate("/approval-list");
        }
      })
      .catch((err) => {
        setApprovalLoading(false);
        const errorMessage =
          err?.message || err?.error || "Gagal melakukan approval";
        alert(`❌ ${errorMessage}`);
        console.error("Approval error:", err);
      });
  }

  function handleReConfirm() {
    if (!jobRequest.dataDetail?.JRID) {
      alert("⚠️ Data JR tidak tersedia");
      return;
    }

    if (!window.confirm("Apakah Anda yakin ingin melakukan Re-Confirm?")) {
      return;
    }

    setApprovalLoading(true);

    dispatch(
      reConfirm({
        JRID: jobRequest.dataDetail.JRID,
        Status: "",
        Revisi: "",
      }),
    )
      .unwrap()
      .then(() => {
        alert("✅ Re-Confirm berhasil");
        navigate("/approval-list");
      })
      .catch((err) => {
        setApprovalLoading(false);
        const errorMessage =
          err?.message || err?.error || "Gagal melakukan Re-Confirm";
        alert(`❌ ${errorMessage}`);
        console.error("ReConfirm error:", err);
      });
  }

  useEffect(() => {
    if (!param.state?.JRID) {
      console.warn("JRID not provided in navigation state - redirecting to approval-list");
      navigate("/approval-list", { replace: true });
      return;
    }

    dispatch(getJobRequestDetailActivity({ JRID: param.state.JRID }));
    dispatch(getMinKendaraan({ search: "" }));
    dispatch(getMinJetty({ search: "" }));
    dispatch(getMinOum({ search: "" }));
    dispatch(getMinKemasan({ search: "" }));
    dispatch(getMinLabour({ search: "" }));
    dispatch(getMinRoom({ search: "" }));
    dispatch(getMinLimbah({ search: "" }));
    dispatch(getMinTypeOfClothing({ search: "" }));
    dispatch(getMinGudang({ search: "" }));
    dispatch(getMinFuel({ search: "" }));
    dispatch(getMinDistention({ search: "" }));
  }, [dispatch, param.state?.JRID, navigate]);

  useEffect(() => {
    if (approval.approvalClient) {
      navigate("/approval-list");
    }
    if (approvalClient.approvalClient) {
      navigate("/");
    }
  }, [approval.approvalClient, approvalClient.approvalClient, navigate]);

  function diff_minutes(dt2, dt1) {
    if (!dt2 || !dt1) return "00:00";
    
    dt2 = new Date(dt2);
    dt1 = new Date(dt1);
    
    if (isNaN(dt2.getTime()) || isNaN(dt1.getTime())) {
      return "00:00";
    }
    
    if (dt2 && dt1) {
      let start = moment(dt2);
      let end = moment(dt1);
      let diff = "";
      if (dt2 < dt1) {
        diff = end.diff(start);
        let result = moment.utc(diff).format("D");
        let resultHour = moment.utc(diff).format("H");
        let resultMinuts = moment.utc(diff).format("m");
        result -= 1;
        if (resultMinuts < 10) {
          resultMinuts = "0" + resultMinuts;
        }
        if (resultHour < 10) {
          resultHour = "0" + resultHour;
        }

        if (result === 0) {
          return resultHour + ":" + resultMinuts;
        } else {
          return (
            result + " Days and " + resultHour + ":" + resultMinuts + " Hour"
          );
        }
      } else {
        if (dt2.toDateString() === dt1.toDateString()) {
          return "1 days";
        } else {
          return "Start must be less than end";
        }
      }
    }
    
    return "00:00";
  }
  
  const diff_Hour = (start, end) => {
    if (!start || !end) return 0;

    const startTime = new Date(start).getTime();
    const endTime = new Date(end).getTime();

    if (endTime <= startTime) return 0;

    const diffMs = endTime - startTime;
    return diffMs / (1000 * 60 * 60); // hasil JAM (desimal)
  };

  function diff_Hours(dt2, dt1) {
    if (!dt2 || !dt1) return "0 Days";
    
    dt2 = new Date(dt2);
    dt1 = new Date(dt1);
    
    if (isNaN(dt2.getTime()) || isNaN(dt1.getTime())) {
      return "0 Days";
    }
    
    if (dt2 && dt1) {
      let start = moment(dt2);
      let end = moment(dt1);
      let diff = "";
      if (dt2 < dt1) {
        diff = end.diff(start);
        let result = moment.utc(diff).format("D");
        let resultHour = moment.utc(diff).format("H");
        let resultMinuts = moment.utc(diff).format("m");
        if (resultMinuts < 10) {
          resultMinuts = "0" + resultMinuts;
        }
        if (resultHour < 10) {
          resultHour = "0" + resultHour;
        }

        return result + " Days";
      } else {
        if (dt2.toDateString() === dt1.toDateString()) {
          return "1 days";
        } else {
          return "Start must be less than end";
        }
      }
    }
    
    return "0 Days";
  }

  function diff_Day(dateStart, dateEnd) {
    if (!dateStart || !dateEnd) return 0;

    const start = moment(dateStart).startOf("day");
    const end = moment(dateEnd).startOf("day");

    if (end.isBefore(start)) return 0;

    const diffDays = end.diff(start, "days");

    // 🔥 aturan:
    // 0 hari  -> 1
    // > 1 hari -> diff + 1
    return diffDays >= 1 ? diffDays + 1 : 1;
  }

  function handleInsertEquipment() {
    let tempdata = JSON.parse(JSON.stringify(values));
    const Equipment = {
      Unit: "",
      UnitNumber: "",
      StartTime: new Date("July 4 1776 00:00"),
      FinishTime: new Date("July 4 1776 00:00"),
      TotalHour: "00:00",
      HourMeter: "",
      TotalHourMeter: "",
      Remarks: "",
    };
    if (!tempdata.Equipment) {
      tempdata.Equipment = [];
    }
    tempdata.Equipment.push(Equipment);
    editEquipment(tempdata.Equipment);
  }

  function handleInsertCargodoring(activityName) {
    if (!values.Activity) return;

    const tempdata = JSON.parse(JSON.stringify(values.Activity));

    tempdata.forEach((activity, index) => {
      activity.DetailActivity?.forEach((subItem, subIndex) => {
        if (subItem.Name === activityName) {
          // Create NEW object each time to avoid shared reference
          const newDetail = {
            Material: "",
            Package: "",
            Loading: "",
            Unloading: "",
            Remarks: "",
            Total: "",
            UomGeneral: "",
            UomLoading: "",
            UomUnloading: "",
            StartTime: "",
            EndTime: "",
          };

          if (!tempdata[index].DetailActivity[subIndex].Detail) {
            tempdata[index].DetailActivity[subIndex].Detail = [newDetail];
          } else {
            tempdata[index].DetailActivity[subIndex].Detail.push(newDetail);
          }
        }
      });
    });

    changeHandlerActivity(tempdata);
  }

  function handleInsertLabour() {
    let tempdata = JSON.parse(JSON.stringify(values));
    const Labour = {
      LabourDesc: "",
      StartTime: new Date("July 4 1776 00:00"),
      FinishTime: new Date("July 4 1776 00:00"),
      TotalHour: "00:00",
      TotalManPower: "",
      Remarks: "",
    };
    if (!tempdata.Labour) {
      tempdata.Labour = [];
    }
    tempdata.Labour.push(Labour);
    editLabour(tempdata.Labour);
  }

  function handleInsertTrucksEntry() {
    let tempdata = JSON.parse(JSON.stringify(values));
    const TrucksEntry = {
      MaterialDesc: "",
      Transporter: "",
      UnitNumber: "",
      EntryDate: new Date("July 4 1776 00:00"),
      ExitDate: new Date("July 4 1776 00:00"),
      TotalHour: "00:00",
      Remarks: "",
    };
    if (!tempdata.TrucksEntry) {
      tempdata.TrucksEntry = [];
    }
    tempdata.TrucksEntry.push(TrucksEntry);
    editTrucksEntry(tempdata.TrucksEntry);
  }

  function inputGenerator(name, dex, subdex, val, type, i, subs) {
    type = typeof type !== "undefined" ? type : "text";
    let tempdata = JSON.parse(JSON.stringify(values.Activity));
    let data;
    if (subdex !== -1) {
      data = tempdata[dex].DetailActivity[subdex]["Detail"][i];
    } else {
      data = tempdata[dex]["Detail"][i];
    }
    if (type === "text" || type === "number") {
      let classbuilder = "bg-white text-left";
      if (type === "number") {
        classbuilder = "bg-white text-right";
      }
      return (
        <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 ">
          <input
            disabled={true}
            value={val}
            name={name}
            onChange={(e) => changeHandlerCargodoring(e, dex, subdex, i)}
            className={classbuilder}
            type={type}
          />
        </th>
      );
    } else if (type === "Oum") {
      if (parseInt(subs) >= 5) {
      }
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <input
            disabled={true}
            value={filterObjectViewer(oum.minData, val)}
            name={name}
            onChange={(e) => changeHandlerCargodoring(e, dex, subdex, i)}
            className={"bg-white"}
            type="text"
          />
        </td>
      );
    } else if (type === "Feul") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <input
            disabled={true}
            value={filterObjectViewer(feul.minData, val)}
            name={name}
            onChange={(e) => changeHandlerCargodoring(e, dex, subdex, i)}
            className={"bg-white"}
            type="text"
          />
        </td>
      );
    } else if (type === "Limbah1") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <input
            disabled={true}
            value={filterObjectViewer(selectorLimbah, val)}
            name={name}
            onChange={(e) => changeHandlerCargodoring(e, dex, subdex, i)}
            className={"bg-white"}
            type="text"
          />
        </td>
      );
    } else if (type === "LocationUsed") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <input
            disabled={true}
            value={filterObjectViewer(selectorLocationUsed, val)}
            name={name}
            onChange={(e) => changeHandlerCargodoring(e, dex, subdex, i)}
            className={"bg-white"}
            type="text"
          />
        </td>
      );
    } else if (type === "Limbah2") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <input
            disabled={true}
            value={filterObjectViewer(selectorLimbah2, val)}
            name={name}
            onChange={(e) => changeHandlerCargodoring(e, dex, subdex, i)}
            className={"bg-white"}
            type="text"
          />
        </td>
      );
    } else if (type === "Distenation") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <input
            disabled={true}
            value={filterObjectViewer(distention.minData, val)}
            name={name}
            onChange={(e) => changeHandlerCargodoring(e, dex, subdex, i)}
            className={"bg-white"}
            type="text"
          />
        </td>
      );
    } else if (type === "Selector") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <input
            disabled={true}
            value={filterObjectViewer(selector, val)}
            name={name}
            onChange={(e) => changeHandlerCargodoring(e, dex, subdex, i)}
            className={"bg-white"}
            type="text"
          />
        </td>
      );
    } else if (type === "SelectorWSM") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <input
            disabled={true}
            value={filterObjectViewer(selector, val)}
            name={name}
            onChange={(e) => changeHandlerCargodoring(e, dex, subdex, i)}
            className={"bg-white"}
            type="text"
          />
        </td>
      );
    } else if (type === "Jetty") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <input
            disabled={true}
            value={filterObjectViewer(jetty.minData, val)}
            name={name}
            onChange={(e) => changeHandlerCargodoring(e, dex, subdex, i)}
            className={"bg-white"}
            type="text"
          />
        </td>
      );
    } else if (type === "kelompokKendaraan") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <input
            disabled={true}
            value={filterObjectViewer(Kelompok, val)}
            name={name}
            onChange={(e) => changeHandlerCargodoring(e, dex, subdex, i)}
            className={"bg-white"}
            type="text"
          />
        </td>
      );
    } else if (type === "PackagePort") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <input
            disabled={true}
            value={filterObjectViewer(kemasan.minData, val)}
            name={name}
            onChange={(e) => changeHandlerCargodoring(e, dex, subdex, i)}
            className={"bg-white"}
            type="text"
          />
        </td>
      );
    } else if (type === "OperationType") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <input
            disabled={true}
            value={val}
            name={name}
            onChange={(e) => changeHandlerCargodoring(e, dex, subdex, i)}
            className={"bg-white"}
            type="text"
          />
        </td>
      );
    } else if (type === "SelectorKendaraan") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <input
            disabled={true}
            value={filterObjectViewer(selector, val)}
            name={name}
            onChange={(e) => changeHandlerCargodoring(e, dex, subdex, i)}
            className={"bg-white"}
            type="text"
          />
        </td>
      );
    } else if (type === "TypeOfCloth") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <input
            disabled={true}
            value={filterObjectViewer(typeOfCloth.minData, val)}
            name={name}
            onChange={(e) => changeHandlerCargodoring(e, dex, subdex, i)}
            className={"bg-white"}
            type="text"
          />
        </td>
      );
    } else if (type === "PackageWSM") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <input
            disabled={true}
            value={filterObjectViewer(kemasan.minData, val)}
            name={name}
            onChange={(e) => changeHandlerCargodoring(e, dex, subdex, i)}
            className={"bg-white"}
            type="text"
          />
        </td>
      );
    } else if (type === "equipment") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <input
            disabled={true}
            value={filterObjectViewer(equipment, val)}
            name={name}
            onChange={(e) => changeHandlerCargodoring(e, dex, subdex, i)}
            className={"bg-white"}
            type="text"
          />
        </td>
      );
    } else if (type === "date") {
      if (val === "") {
        val = new Date();
      }
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <DatePicker
            disabled={true}
            dateFormat="dd/MMMM/yyyy"
            selected={new Date(val)}
            className={"bg-white text-center"}
            onChange={(text) =>
              changeHandlerTimeoum(name, text, dex, subdex, i)
            }
          />
        </td>
      );
    } else if (type === "time") {
      if (val === "") {
        val = new Date();
      }
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <DatePicker
            showTimeSelectOnly
            showTimeInput
            disabled={true}
            showTimeSelect
            dateFormat="HH:mm"
            timeFormat={"HH:mm"}
            selected={new Date(val)}
            className={"bg-white text-center"}
            onChange={(text) =>
              changeHandlerTimeoum(name, text, dex, subdex, i)
            }
          />
        </td>
      );
    } else if (type === "button") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          {i + 1}
        </td>
      );
    } else if (type === "time") {
      if (val === "") {
        val = new Date();
      }
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <DatePicker
            disabled={true}
            showTimeSelectOnly
            showTimeInput
            dateFormat="HH:mm"
            selected={new Date(val)}
            className={"bg-white text-center"}
            onChange={(text) =>
              changeHandlerTimeoum(name, text, dex, subdex, i)
            }
          />
        </td>
      );
    } else if (type === "totalTime") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-right">
          {diff_minutes(data["date1"], data["date2"])}
        </td>
      );
    } else if (type === "totalDays") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          {diff_Hours(data["date1"], data["date2"])}
        </td>
      );
    } else if (type === "totalDays2") {
      const totalDays = diff_Day(data.date1, data.date2);

      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          {totalDays}
        </td>
      );
    } else if (type === "TRoom") {
      const totalDays2 = diff_Day(data.date1, data.date2);
      const qty = Number(data.form6 || 0);

      // 🔥 TRoom = (totalDays2 * form6) * 75%
      const totalRoom = totalDays2 * qty;

      return (
        <td className="border-b border-gray-200 text-right px-2 py-1">
          {totalRoom ? Math.round(totalRoom).toLocaleString("id-ID") : "0"}
        </td>
      );
    } else if (type === "TMeal") {
      const qty = Number(data.form6 || 0);

      // Total Meal langsung dari Qty, tidak terpengaruh tanggal
      const totalMeal = qty;

      return (
        <td className="border-b border-gray-200 text-right px-2 py-1">
          {totalMeal > 0 ? totalMeal.toLocaleString("id-ID") : "0"}
        </td>
      );
    } else if (type === "numbering") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-center">
          {i + 1}
        </td>
      );
    } // Di dalam inputGenerator function, perbaiki case untuk "SBerthing":
    else if (type === "SBerthing") {
      const rowKey = `${dex}-${subdex}-${i}-${name}`;
      const currentValue = data[name] || "";

      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          <select
            value={currentValue}
            onChange={(e) => {
              const val = e.target.value;

              // Update langsung ke data
              if (subdex === -1) {
                tempdata[dex].Detail[i][name] = val;
              } else {
                tempdata[dex].DetailActivity[subdex]["Detail"][i][name] = val;
              }

              // Update state
              changeHandlerActivity(tempdata);

              // Juga update berthingActivity state untuk tracking
              setBerthingActivity((prev) => ({
                ...prev,
                [rowKey]: val,
              }));
            }}
            className="appearance-none block w-40 text-gray-700 py-2 px-2 border border-gray-200 rounded leading-tight outline-none bg-white border-gray-500"
          >
            <option value="">-- Pilih Aktivitas --</option>
            <option value="Standby">Standby</option>
            <option value="Loading/Unloading">Loading/Unloading</option>
          </select>
        </td>
      );
    } else if (type === "TBerthing") {
      const rowKey = `${dex}-${subdex}-${i}-form5`; // key untuk form5 (SBerthing)
      const activity = data["form5"] ? data["form5"].toLowerCase() : "";

      let hours = 0;

      if (data["date1"] && data["date2"]) {
        const raw = diff_Hour(data["date1"], data["date2"]);
        hours = activity === "standby" ? Math.min(raw, 4) : raw;
      }

      // Format jam dengan 2 desimal
      const formattedHours = hours.toFixed(2);

      // Simpan nilai ke field form4
      if (subdex === -1) {
        tempdata[dex].Detail[i]["form4"] = formattedHours;
      } else {
        tempdata[dex].DetailActivity[subdex]["Detail"][i]["form4"] =
          formattedHours;
      }

      // Update state jika nilai berubah
      if (data["form4"] !== formattedHours) {
        changeHandlerActivity(tempdata);
      }

      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
          {formattedHours}
        </td>
      );
    } else if (type === "TDimension") {
      const length = Number(data.form4 || 0);
      const wide = Number(data.form5 || 0);
      const height = Number(data.form6 || 0);

      const totalDimension = length * wide * height;

      return (
        <td className="border-b border-gray-200 align-middle text-sm px-2 py-1 text-right">
          {totalDimension
            ? Math.round(totalDimension).toLocaleString("id-ID")
            : "0"}
        </td>
      );
    } else if (type === "TArarental") {
      const length = Number(data.form4 || 0);
      const wide = Number(data.form5 || 0);
      const height = Number(data.form6 || 0);

      const quantity = Number(data.form2 || 0);

      const totalDimension = length * wide * height;
      const totalRental = totalDimension * quantity;

      return (
        <td className="border-b border-gray-200 text-right px-2 py-1">
          {totalRental ? Math.round(totalRental).toLocaleString("id-ID") : "0"}
        </td>
      );
    } else if (type === "TotalFuel") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-right">
          {data["form4"] - data["form3"]}
        </td>
      );
    } else if (type === "totalDrill") {
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-right">
          {Math.abs(parseInt(data["form4"]) - parseInt(data["form5"]))}
        </td>
      );
    } else if (type === "dateTime") {
      if (val === "") {
        val = new Date();
      }
      return (
        <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-right">
          <DatePicker
            disabled={true}
            showTimeInput
            showTimeSelect
            dateFormat="dd/MMMM/yyyy HH:mm"
            timeFormat={"dd/MMMM/yyyy HH:mm"}
            selected={new Date(val)}
            className={"bg-white text-center"}
            onChange={(text) =>
              changeHandlerTimeoum(name, text, dex, subdex, i)
            }
          />
        </td>
      );
    }
  }

  function deleteTrucksEntry(i) {
    let tempdata = JSON.parse(JSON.stringify(values));
    tempdata.TrucksEntry.splice(i, 1);
    editTrucksEntry(tempdata.TrucksEntry);
  }

  function deleteLabour(i) {
    let tempdata = JSON.parse(JSON.stringify(values));
    tempdata.Labour.splice(i, 1);
    editLabour(tempdata.Labour);
  }

  function deleteActivity(ind, i, z) {
    let tempdata = JSON.parse(JSON.stringify(values.Activity));
    if (tempdata) {
      if (z === -1) {
        tempdata[ind].Detail.splice(i, 1);

        changeHandlerActivity(tempdata);
      } else {
        tempdata[ind].DetailActivity[z]["Detail"].splice(i, 1);
        changeHandlerActivity(tempdata);
      }
    }
  }

  function deleteEquipment(i) {
    let tempdata = JSON.parse(JSON.stringify(values));
    tempdata.Equipment.splice(i, 1);
    editEquipment(tempdata.Equipment);
  }

  useEffect(() => {
    if (jobRequest.isGetDetailSuccess && !firstLoading && jobRequest.dataDetail) {
      if (!quatation.isGetSuccess && !quatation.isGetFetching)
        dispatch(
          getQuatationOperasional({
            QuatationNo: jobRequest.dataDetail.QuatationNo,
          }),
        );
      if (quatation.isGetSuccess && !firstLoading) {
        let EquipmentPicker = [];
        let LabourPicker = [];
        let Trucks = [];

        quatation.data.Equipment &&
          quatation.data.Equipment.map(({ Unit }, index) => {
            EquipmentPicker.push(Unit);
          });
        quatation.data.Labour &&
          quatation.data.Labour.map(({ Labour }, index) => {
            LabourPicker.push(Labour);
          });
        quatation.data.Truck &&
          quatation.data.Truck.map(({ Description }, index) => {
            Trucks.push({ value: Description, label: Description });
          });
        let tempdata = JSON.parse(
          JSON.stringify(jobRequest.dataDetail.Activity),
        );
        if (!values.Activity || values.Activity.length === 0) {
          changeHandlerActivity(jobRequest.dataDetail.Activity);
        }
        const initValues = {
          PermitToWork: jobRequest.dataDetail.PermitToWork,
          Status: jobRequest.dataDetail.Status,
          ShippingManifest: jobRequest.dataDetail.ShippingManifest,
          ShippingManifestDetail: jobRequest.dataDetail.ShippingManifestDetail,
          NamaKlien: jobRequest.dataDetail.NamaKlien,
          IncomingDate: jobRequest.dataDetail.IncomingDate,
          QuatationNo: jobRequest.dataDetail.QuatationNo,
          SPKNo: jobRequest.dataDetail.SPKNo,
          Priority: jobRequest.dataDetail.Priority,
          KlienID: jobRequest.dataDetail.KlienID,
          StatusKet: jobRequest.dataDetail.StatusKet,
          Activity: tempdata,
          TrucksEntry: jobRequest.dataDetail.TruckEntry,
          Labour: jobRequest.dataDetail.Labour,
          Equipment: jobRequest.dataDetail.Equipment,
          RequestUnit: jobRequest.dataDetail.RequestUnit,
        };
        editHandler(initValues);
        setTanggal(
          jobRequest?.dataDetail?.Date
            ? new Date(jobRequest.dataDetail.Date)
            : null,
        );
        setTanggalIncoming(
          jobRequest?.dataDetail?.IncomingDate
            ? new Date(jobRequest.dataDetail.IncomingDate)
            : null,
        );
        let AllLimbah = false;
        let AllRoom = false;

        let WSMPicker = [];
        let LocationUsedPicker = [];
        let tempMaterialSupply = [];
        quatation.data?.Activity?.forEach(({ Name, DetailActivity }, index) => {
          if (
            Name === "GENERAL_SERVICE" ||
            Name === "WASTE_MANAGEMENT_SERVICES"
          ) {
            DetailActivity &&
              DetailActivity.map(
                ({ DetailUnit, Surname, Category }, SubIndex) => {
                  if (DetailUnit === "ROOM") {
                    if (Surname === "Room All") {
                      room.minData.map((data, i) => {
                        if (data.label !== "All") {
                          let tempArray = {
                            value: data.label,
                            category: "7",
                            label: data.label,
                          };
                          setSelector((selector) => [tempArray, ...selector]);
                        }
                      });
                    } else {
                      let tempArray = {
                        value: Surname,
                        category: "7",
                        label: Surname,
                      };
                      setSelector((selector) => [tempArray, ...selector]);
                    }
                  } else if (DetailUnit === "MEALS") {
                    let tempArray = {
                      value: Surname,
                      category: "8",
                      label: Surname,
                    };
                    setSelector((selector) => [tempArray, ...selector]);
                  } else if (DetailUnit === "WOODEN") {
                    LocationUsedPicker.push(Surname);
                    let tempArray = {
                      value: Surname,
                      category: "9",
                      label: Surname,
                    };
                    setSelector((selector) => [tempArray, ...selector]);
                  } else if (DetailUnit === "Drill") {
                    let tempArray = {
                      value: Surname,
                      category: "10",
                      label: Surname,
                    };
                    setSelector((selector) => [tempArray, ...selector]);
                  } else if (DetailUnit === "Others") {
                    tempMaterialSupply.push(Category);
                    let tempArray2 = { value: Category, label: Category };
                    setMaterialSupply((selector) => [tempArray2, ...selector]);
                    let tempArray = {
                      value: Surname,
                      category: "11",
                      label: Surname,
                    };
                    setSelector((selector) => [tempArray, ...selector]);
                  } else if (DetailUnit === "Vehicle") {
                    let tempArray = {
                      value: Surname,
                      category: "12",
                      label: Surname,
                    };
                    setSelector((selector) => [tempArray, ...selector]);
                  } else if (Name === "WASTE_MANAGEMENT_SERVICES") {
                    if (DetailUnit === "0") {
                      AllLimbah = true;
                    }
                    WSMPicker.push(DetailUnit);
                  }
                  if (DetailActivity[SubIndex]["Name"] === "Clearance Doc") {
                    let tempArray = {
                      value: Category,
                      category: "15",
                      label: Category,
                    };
                    setSelector((selector) => [tempArray, ...selector]);
                  }

                  if (DetailActivity[SubIndex]["Name"] === "Material Supply") {
                    let tempArray = {
                      value: Category,
                      category: "16",
                      label: Category,
                    };
                    setSelector((selector) => [tempArray, ...selector]);
                  }
                },
              );
          }
        });
        let res = limbah.minDataKode?.filter((e) => WSMPicker.includes(e.value)) || [];
        let res2 = limbah.minData?.filter((e) => WSMPicker.includes(e.value)) || [];
        const res3 = locationUsed.minData?.filter((e) =>
          LocationUsedPicker.includes(e.categoryName),
        ) || [];
        const res4 = kendaraan.minData?.filter((e) =>
          EquipmentPicker.includes(e.value),
        ) || [];
        const res5 = labour.minData?.filter((e) =>
          LabourPicker.includes(e.value),
        ) || [];
        if (AllLimbah)
          res = limbah.minDataKode?.filter(
            (e) => !WSMPicker.includes(e.value) && e.label !== "-",
          ) || [];
        if (AllLimbah)
          res2 = limbah.minData?.filter((e) => !WSMPicker.includes(e.value)) || [];

        setSelectorLimbah(res);
        setSelectorLimbah2(res2);
        setSelectorLocationUsed(res3);
        setSelectorEquipment(res4);
        setSelectorLabour(res5);
        setSelectorTrucks(Trucks);

        jobRequest.dataDetail.Activity.map(
          ({ Name, DetailActivity, Checked, Detail }, index) => {
            let subs = "1";
            if (Name === "PORT_SERVICES") {
              if (Checked) {
                setCheckedState(true);
              }
            }
            if (Name === "GENERAL_SERVICE") {
              subs = "5";
            }
            if (
              Name !== "RENTAL" &&
              Name !== "WASTE_MANAGEMENT_SERVICES" &&
              Name !== "AREA_RENTAL" &&
              Name !== "MANPOWER"
            ) {
              DetailActivity &&
                DetailActivity.map((keyName, i) => {
                  if (Name !== "GENERAL_SERVICE") {
                    let tempArray = {
                      value: keyName["Surname"],
                      category: subs,
                      label: keyName["Surname"],
                    };
                    setSelector((selector) => [tempArray, ...selector]);
                  }
                });
            }
          },
        );
        if (jobRequest.dataDetail.Selector) {
          setSelector((selector) => [
            ...jobRequest.dataDetail.Selector,
            ...selector,
          ]);
        }
        dispatch(changeResponseSucess());
        setFirstLoading(true);
      }
    }
    // Removed duplicate navigation logic - handled by separate useEffect
  });

  function handleInsertServices(index, subIndex) {
    if (!values.Activity) return;

    let tempdata = JSON.parse(JSON.stringify(values.Activity));
    
    // Create NEW object each time to avoid shared reference
    const newDetail = {
      form1: "",
      form2: "",
      form3: "",
      form4: "",
      form5: "",
      form6: "",
      form7: "",
      form8: "",
      form9: "",
      UoM: "",
      date1: new Date(),
      date2: new Date(),
    };
    
    if (subIndex === -1) {
      if (tempdata[index].Detail) {
        tempdata[index].Detail = [...tempdata[index].Detail, newDetail];
      } else {
        tempdata[index].Detail = [newDetail];
      }
    } else {
      if (tempdata[index].DetailActivity[subIndex].Detail) {
        tempdata[index].DetailActivity[subIndex].Detail = [
          ...tempdata[index].DetailActivity[subIndex].Detail,
          newDetail,
        ];
      } else {
        tempdata[index].DetailActivity[subIndex].Detail = [newDetail];
      }
    }

    changeHandlerActivity(tempdata);
  }

  const GMArray = [
    { id: "Accomodation/Room", DetailUnit: "ROOM" },
    { id: "MEALS", DetailUnit: "MEALS" },
    { id: "Laundry", DetailUnit: "LAUNDRY" },
    { id: "Wooden Dunnage & Pallet Wraping", DetailUnit: "WOODEN" },
    { id: "Drill & Fresh Water", DetailUnit: "Drill" },
    { id: "Fuel", DetailUnit: "Fuel" },
    { id: "Vehicle Rental", DetailUnit: "Vehicle" },
    { id: "Clearance Doc", DetailUnit: "Clearance Doc" },
    { id: "Material Supply", DetailUnit: "Material_Supply" },
    // {id: "Drill Water", DetailUnit: "Drill"},
  ];

  if (!firstLoading && !approvalLoading) {
    return <Loading />;
  } else {
    return (
      <>
        <div className={param.state.isClient ? "" : "md:ml-64"}>
          <div
            style={{ background: Colors.white }}
            className="pt-14 pb-16 px-3 md:px-8 h-auto"
          >
            <div className="container mx-auto max-w-full">
              <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
            </div>
          </div>
          <div className="px-3 md:px-8 h-auto -mt-32">
            <div className="flex w-full justify-end p-4 flex-col sm:flex-row pt-4">
              <button
                onClick={() => {
                  if (param.state.isClient) {
                    navigate("/");
                  } else {
                    navigate("/approval-list");
                  }
                }}
                className="flex flex-row items-center justify-center m-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
              >
                <BiArrowBack className="text-xl text-gray-800 pr-2" />
                Kembali
              </button>
              {!param.state.isClient && (
                <button
                  onClick={() => handleReConfirm()}
                  disabled={approvalLoading}
                  className="flex flex-row items-center justify-center text-red-700 m-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {approvalLoading ? "Processing..." : "Re-Conform"}
                </button>
              )}
              <button
                onClick={() => handleInsertJR()}
                disabled={approvalLoading}
                className="flex flex-row items-center justify-center text-green-700 m-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {approvalLoading ? "Processing..." : "Approve"}
              </button>
            </div>
            <div className="flex flex-row">
              <div className="px-4 py-4 flex-1">
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Nomor Quatation
                    </label>
                    <div className="inline-block relative w-full">
                      <input
                        disabled
                        value={values.QuatationNo}
                        onChange={changeHandler}
                        name="QuatationNo"
                        className={
                          (touched.QuatationNo || buttonTouched) &&
                          errors.QuatationNo
                            ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                            : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                        }
                        type="text"
                      />
                    </div>
                    {(touched.QuatationNo || buttonTouched) &&
                      errors.QuatationNo && (
                        <p className="text-red-500 text-xs italic">
                          {errors.QuatationNo}
                        </p>
                      )}
                  </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Nomor SPK
                    </label>
                    <input
                      disabled
                      value={values.SPKNo}
                      onChange={changeHandler}
                      name="SPKNo"
                      className={
                        (touched.SPKNo || buttonTouched) && errors.SPKNo
                          ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                          : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                      }
                      type="text"
                    />
                    {(touched.SPKNo || buttonTouched) && errors.SPKNo && (
                      <p className="text-red-500 text-xs italic">
                        {errors.SPKNo}
                      </p>
                    )}
                  </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full px-3">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Priority
                    </label>
                    <div className="inline-block relative w-full  ">
                      <input
                        disabled
                        value={values.Priority}
                        name="Priority"
                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full px-3">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Request Unit
                    </label>
                    <div className="inline-block relative w-full  ">
                      <input
                        disabled
                        value={values.RequestUnit}
                        name="Priority"
                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                        type="text"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="p-4 flex-1">
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Client
                    </label>
                    <input
                      disabled
                      value={values.NamaKlien}
                      onChange={changeHandler}
                      name="KlienID"
                      className={
                        (touched.NamaKlien || buttonTouched) && errors.NamaKlien
                          ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                          : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                      }
                      type="text"
                    />
                    {(touched.NamaKlien || buttonTouched) &&
                      errors.NamaKlien && (
                        <p className="text-red-500 text-xs italic">
                          {errors.NamaKlien}
                        </p>
                      )}
                  </div>
                </div>
                <div className="flex flex-wrap -mx-3">
                  <div className="w-full px-3 mb-6">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Tanggal
                    </label>
                    <DatePicker
                      className={
                        "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                      }
                      disabled
                      selected={Tanggal}
                    />
                    {!isValidTanggal && (
                      <p className="text-red-500 text-xs italic">
                        Tanggal pengajuan wajib diisi
                      </p>
                    )}
                  </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Shipping Manifest
                    </label>
                    <div className="inline-block relative w-full">
                      <div
                        className="appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                        onClick={() =>
                          setModalShippingManifest(!modalShippingManifest)
                        }
                        type="text"
                      >
                        {values.ShippingManifest}
                      </div>
                      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                        <svg
                          className="fill-current h-4 w-4"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 491.52 491.52"
                        >
                          <ellipse
                            cx="158.537"
                            cy="158.536"
                            rx="129.777"
                            ry="129.777"
                          />
                          <path
                            d="M98.081,234.62c-43.316-43.315-43.882-112.979-1.264-155.595
	c9.509-9.511,20.41-16.745,32.021-21.96c-16.497,4.812-32.056,13.702-45.064,26.71c-41.288,41.289-41.289,108.231,0,149.521
	c18.282,18.281,41.596,28.431,65.483,30.523C130.561,258.986,112.79,249.33,98.081,234.62z"
                          />
                          <path
                            d="M270.636,46.433c-61.912-61.912-162.291-61.911-224.202,0.001s-61.912,162.291-0.001,224.202
	c57.054,57.054,146.703,61.394,208.884,13.294l14.18,14.182l28.615-28.613l-14.182-14.182
	C332.029,193.137,327.69,103.487,270.636,46.433z M250.301,250.302c-50.681,50.681-132.852,50.681-183.534,0
	c-50.68-50.681-50.68-132.852,0.002-183.533s132.85-50.681,183.531,0C300.982,117.45,300.982,199.621,250.301,250.302z"
                          />
                          <path
                            d="M305.823,258.865l-46.959,46.958c-2.669,2.67-2.669,6.996,0,9.665l174.339,174.338
	c12.132,12.133,68.755-44.49,56.623-56.623L315.488,258.865C312.819,256.196,308.493,256.196,305.823,258.865z"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Incoming Date / Time
                    </label>
                    <DatePicker
                      disabled
                      className={
                        !isValidTanggalIncoming
                          ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                          : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                      }
                      selected={TanggalIncoming}
                      onChange={(date) => {
                        setTanggalIncoming(date);
                        setIsValidTanggalIncoming(true);
                      }}
                    />
                    {!isValidTanggalIncoming && (
                      <p className="text-red-500 text-xs italic">
                        Tanggal Incoming wajib diisi
                      </p>
                    )}
                  </div>
                </div>
                <div className="flex flex-wrap -mx-3 mb-6">
                  <div className="w-full px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Permit to Work No *
                    </label>
                    <input
                      value={values.PermitToWork}
                      onChange={changeHandler}
                      name="PermitToWork"
                      className={
                        (touched.PermitToWork || buttonTouched) &&
                        errors.PermitToWork
                          ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                          : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                      }
                      type="text"
                    />
                    {(touched.PermitToWork || buttonTouched) &&
                      errors.PermitToWork && (
                        <p className="text-red-500 text-xs italic">
                          {errors.PermitToWork}
                        </p>
                      )}
                  </div>
                </div>
              </div>
            </div>
            <div className="p-4">
              <label className="block uppercase tracking-wide text-gray-700 text-l font-bold mb-2">
                Detail Activity
              </label>
              <div key={"Act"} className="flex flex-wrap -mx-3 px-3 mb-6 ">
                <div
                  style={{
                    background: Colors.primary,
                  }}
                  className={`w-full px-4 border border-gray-500 activity rounded  py-3 text-gray-700 hover:bg-light-blue-500 hover:text-white cursor-pointer text-white border-0 rounded-t rounded-b-none`}
                >
                  Services
                </div>
                <Card className="flex flex-col items-center content-center rounded-t-none ">
                  {values.Activity !== null &&
                    values.Activity.map(
                      ({ Name, DetailActivity, Detail }, index) => {
                        if (DetailActivity) {
                          if (Name === "PORT_SERVICES") {
                            return (
                              DetailActivity !== null &&
                              DetailActivity.map((keyName, i) => {
                                let mapping = keyName["Name"];

                                if (keyName["Name"] === "Stevedoring") {
                                  mapping = "Port_Service_Common";
                                }
                                if (keyName["Name"] === "Liquid") {
                                  mapping = "Liquid";
                                  keyName["Surname"] = "Liquid Transfer";
                                }
                                if (
                                  keyName["Name"] ===
                                    "Receiving_Using_Forklift" ||
                                  keyName["Name"] === "Receiving_Using_Crane"
                                ) {
                                  mapping = "Port_Service_External";
                                }
                                if (
                                  keyName["Name"] ===
                                    "Delivery_Using_Forklift" ||
                                  keyName["Name"] === "Delivery_Using_Crane"
                                ) {
                                  mapping = "Port_Service_External";
                                }
                                if (
                                  keyName["Name"] === "Delivery" ||
                                  keyName["Name"] === "Receiving" ||
                                  keyName["Name"] === "Stacking"
                                ) {
                                  mapping = "Port_Service_External";
                                }
                                if (Name === "RENTAL") {
                                  mapping = "Rental";
                                }
                                if (Name === "AREA_RENTAL") {
                                  mapping = "AreaRental";
                                }
                                if (Name === "MANPOWER") {
                                  mapping = "ManPower";
                                }
                                if (Name === "WASTE_MANAGEMENT_SERVICES") {
                                  mapping = "WSM";
                                }
                                if (Name === "Vessel_Service") {
                                  mapping = "Vessel_Service";
                                }
                                if (Name === "Vessel_Berthing") {
                                  mapping = "Vessel_Berthing";
                                }
                                const simpleObjectDraver =
                                  objectDrawer[mapping];
                                if (
                                  simpleObjectDraver !== undefined &&
                                  keyName["Detail"]
                                ) {
                                  return (
                                    <React.Fragment key={`${Name}-${keyName.Name || keyName.Surname}-${i}`}>
                                      <hr />
                                      <CardBody className="w-full mt-5 ">
                                        <label className="block uppercase tracking-wide text-gray-700 text-l font-bold mb-2">
                                          {Name.replace(/[_]/g, " ")} -{" "}
                                          {keyName["Surname"].replace(
                                            /[_]/g,
                                            " ",
                                          )}
                                        </label>
                                        <div className="overflow-x-auto">
                                          <table className="table-auto w-full bg-transparent border-collapse ">
                                            <thead>
                                              <tr>
                                                {simpleObjectDraver[
                                                  "header_upper"
                                                ] !== null &&
                                                  simpleObjectDraver[
                                                    "header_upper"
                                                  ].map((keyName, idx) => (
                                                    <th
                                                      key={`header-upper-${idx}`}
                                                      rowSpan={
                                                        keyName["rowSpan"]
                                                      }
                                                      colSpan={
                                                        keyName["colSpan"]
                                                      }
                                                      style={{
                                                        color: Colors.primary,
                                                      }}
                                                      className="font-bold px-2  align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-center"
                                                    >
                                                      {keyName["text"]}
                                                    </th>
                                                  ))}
                                              </tr>
                                              <tr>
                                                {simpleObjectDraver[
                                                  "header"
                                                ] !== null &&
                                                  simpleObjectDraver[
                                                    "header"
                                                  ].map((keyName, idx) => (
                                                    <th
                                                      key={`header-${idx}`}
                                                      rowSpan={
                                                        keyName["rowSpan"]
                                                      }
                                                      colSpan={
                                                        keyName["colSpan"]
                                                      }
                                                      style={{
                                                        color: Colors.primary,
                                                      }}
                                                      className="font-bold px-2  align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-center"
                                                    >
                                                      {keyName["text"]}
                                                    </th>
                                                  ))}
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {keyName["Detail"] &&
                                                keyName["Detail"].map(
                                                  (DetailKey, z) => {
                                                    return (
                                                      <tr key={`detail-${index}-${i}-${z}`}>
                                                        {simpleObjectDraver[
                                                          "body"
                                                        ] !== null &&
                                                          simpleObjectDraver[
                                                            "body"
                                                          ].map((field, fieldIdx) => (
                                                            <React.Fragment key={`field-${index}-${i}-${z}-${fieldIdx}`}>
                                                              {inputGenerator(
                                                                field["name"],
                                                                index,
                                                                i,
                                                                DetailKey[
                                                                  field["key"]
                                                                ],
                                                                field["type"],
                                                                z,
                                                                "1",
                                                              )}
                                                            </React.Fragment>
                                                          ))}
                                                      </tr>
                                                    );
                                                  },
                                                )}
                                            {/* Footer Summary untuk Port_Service_Common (Stevedoring, dll) - Total Quantity */}
                                            {mapping === "Port_Service_Common" && keyName["Detail"] && keyName["Detail"].length > 0 && (
                                              <tr className="bg-gray-100 font-bold">
                                                <td colSpan="4" className="px-2 py-2 border-t border-gray-300 text-right text-sm uppercase">
                                                  Total Quantity
                                                </td>
                                                <td className="px-2 py-2 border-t border-gray-300 text-center text-green-700">
                                                  {keyName["Detail"].reduce((sum, item) => sum + (Number(item.form4) || 0), 0).toLocaleString("id-ID")}
                                                </td>
                                                <td colSpan="2" className="border-t border-gray-300"></td>
                                              </tr>
                                            )}
                                            {/* Footer Summary untuk Cargodoring - Total Loading Quantity */}
                                            {mapping === "Cargodoring" && keyName["Detail"] && keyName["Detail"].length > 0 && (
                                              <tr className="bg-gray-100 font-bold">
                                                <td colSpan="3" className="px-2 py-2 border-t border-gray-300 text-right text-sm uppercase">
                                                  Total Loading Quantity
                                                </td>
                                                <td className="px-2 py-2 border-t border-gray-300 text-center text-green-700">
                                                  {keyName["Detail"].reduce((sum, item) => sum + (Number(item.form4) || 0), 0).toLocaleString("id-ID")}
                                                </td>
                                                <td colSpan="3" className="border-t border-gray-300"></td>
                                              </tr>
                                            )}
                                            {/* Footer Summary untuk Port_Service_External (Receiving, Delivery, dll) - Total Quantity */}
                                            {mapping === "Port_Service_External" && keyName["Detail"] && keyName["Detail"].length > 0 && (
                                              <tr className="bg-gray-100 font-bold">
                                                <td colSpan="3" className="px-2 py-2 border-t border-gray-300 text-right text-sm uppercase">
                                                  Total Quantity
                                                </td>
                                                <td className="px-2 py-2 border-t border-gray-300 text-center text-green-700">
                                                  {keyName["Detail"].reduce((sum, item) => sum + (Number(item.form4) || 0), 0).toLocaleString("id-ID")}
                                                </td>
                                                <td colSpan="2" className="border-t border-gray-300"></td>
                                              </tr>
                                            )}
                                            {/* Footer Summary untuk Bulk_Transfer / Liquid - Total */}
                                            {(mapping === "Bulk_Transfer" || mapping === "Liquid") && keyName["Detail"] && keyName["Detail"].length > 0 && (
                                              <tr className="bg-gray-100 font-bold">
                                                <td colSpan="6" className="px-2 py-2 border-t border-gray-300 text-right text-sm uppercase">
                                                  Total
                                                </td>
                                                <td className="px-2 py-2 border-t border-gray-300 text-center text-green-700">
                                                  {keyName["Detail"].reduce((sum, item) => {
                                                    const total = (Number(item.form4) || 0) - (Number(item.form3) || 0);
                                                    return sum + total;
                                                  }, 0).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                </td>
                                                <td colSpan="2" className="border-t border-gray-300"></td>
                                              </tr>
                                            )}
                                            {/* Footer Summary untuk Vessel_Berthing - Total Hours */}
                                            {mapping === "Vessel_Berthing" && keyName["Detail"] && keyName["Detail"].length > 0 && (
                                              <tr className="bg-gray-100 font-bold">
                                                <td colSpan="6" className="px-2 py-2 border-t border-gray-300 text-right text-sm uppercase">
                                                  Total Hours
                                                </td>
                                                <td className="px-2 py-2 border-t border-gray-300 text-center text-blue-700">
                                                  {keyName["Detail"].reduce((sum, item) => {
                                                    if (item.date1 && item.date2) {
                                                      const start = new Date(item.date1).getTime();
                                                      const end = new Date(item.date2).getTime();
                                                      if (end > start) {
                                                        const hours = (end - start) / (1000 * 60 * 60);
                                                        const activity = item.form5 ? item.form5.toLowerCase() : "";
                                                        return sum + (activity === "standby" ? Math.min(hours, 4) : hours);
                                                      }
                                                    }
                                                    return sum + (Number(item.form4) || 0);
                                                  }, 0).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                </td>
                                                <td className="px-2 py-2 border-t border-gray-300"></td>
                                              </tr>
                                            )}
                                            </tbody>
                                          </table>
                                        </div>
                                      </CardBody>
                                    </React.Fragment>
                                  );
                                }
                              })
                            );
                          } else if (Name === "GENERAL_SERVICE") {
                            return GMArray.map(
                              ({ id, DetailUnit }, detailID) => {
                                return (
                                  DetailActivity !== null &&
                                  DetailActivity.map((keyName, i) => {
                                    let mapping = keyName["DetailUnit"];
                                    let units = keyName["DetailUnit"];

                                    if (mapping === "Others") {
                                      if (
                                        keyName["Name"] === "Material Supply"
                                      ) {
                                        units = "Material_Supply";
                                        mapping = "Material_Supply";
                                      } else {
                                        mapping = keyName["Name"];
                                        units = keyName["Name"];
                                      }
                                    }

                                    const simpleObjectDraver =
                                      objectDrawer[mapping];
                                    if (
                                      units === DetailUnit &&
                                      simpleObjectDraver !== undefined
                                    ) {
                                      let subs = "5";

                                      if (keyName["DetailUnit"] === "ROOM") {
                                        subs = "7";
                                      } else if (
                                        keyName["DetailUnit"] === "MEALS"
                                      ) {
                                        subs = "8";
                                      } else if (
                                        keyName["DetailUnit"] === "WOODEN"
                                      ) {
                                        subs = "9";
                                      } else if (
                                        keyName["DetailUnit"] === "Drill"
                                      ) {
                                        subs = "10";
                                      } else if (
                                        keyName["DetailUnit"] === "Others"
                                      ) {
                                        subs = "11";
                                      } else if (
                                        keyName["DetailUnit"] === "Vehicle"
                                      ) {
                                        subs = "12";
                                      }
                                      if (id === "Clearance Doc") {
                                        subs = "15";
                                      }
                                      if (id === "Material Supply") {
                                        subs = "16";
                                      }

                                      // 🔥 HITUNG TOTAL MEAL KHUSUS UNTUK MEALS
                                      let totalMealSummary = 0;
                                      if (
                                        DetailUnit === "MEALS" &&
                                        keyName["Detail"]
                                      ) {
                                        totalMealSummary = keyName[
                                          "Detail"
                                        ].reduce((sum, item) => {
                                          return (
                                            sum + (Number(item.form6) || 0)
                                          );
                                        }, 0);
                                      }

                                      return (
                                        <React.Fragment key={`${Name}-${id}-${i}`}>
                                          <hr />
                                          <CardBody className="w-full mt-5 ">
                                            <label className="block uppercase tracking-wide text-gray-700 text-l font-bold mb-2">
                                              {Name.replace(/[_]/g, " ")} - {id}
                                            </label>
                                            <div className="overflow-x-auto">
                                              <button
                                                onClick={() =>
                                                  handleInsertServices(index, i)
                                                }
                                                className="flex flex-row items-center justify-center m-2 mt-4 mb-4  bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 shadow rounded"
                                              >
                                                Add
                                              </button>
                                              <table className="table-auto w-full bg-transparent border-collapse ">
                                                <thead>
                                                  <tr>
                                                    {simpleObjectDraver[
                                                      "header_upper"
                                                    ] !== null &&
                                                      simpleObjectDraver[
                                                        "header_upper"
                                                      ].map((keyName, idx) => (
                                                        <th
                                                          key={`header-upper-${idx}`}
                                                          rowSpan={
                                                            keyName["rowSpan"]
                                                          }
                                                          colSpan={
                                                            keyName["colSpan"]
                                                          }
                                                          style={{
                                                            color:
                                                              Colors.primary,
                                                          }}
                                                          className="font-bold px-2  align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-center"
                                                        >
                                                          {keyName["text"]}
                                                        </th>
                                                      ))}
                                                  </tr>
                                                  <tr>
                                                    {simpleObjectDraver[
                                                      "header"
                                                    ] !== null &&
                                                      simpleObjectDraver[
                                                        "header"
                                                      ].map((keyName, idx) => (
                                                        <th
                                                          key={`header-${idx}`}
                                                          rowSpan={
                                                            keyName["rowSpan"]
                                                          }
                                                          colSpan={
                                                            keyName["colSpan"]
                                                          }
                                                          style={{
                                                            color:
                                                              Colors.primary,
                                                          }}
                                                          className="font-bold px-2  align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-center"
                                                        >
                                                          {keyName["text"]}
                                                        </th>
                                                      ))}
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {keyName["Detail"] &&
                                                    keyName["Detail"].map(
                                                      (DetailKey, z) => {
                                                        return (
                                                          <tr
                                                            key={`detail-${index}-${i}-${z}`}
                                                          >
                                                            {simpleObjectDraver[
                                                              "body"
                                                            ] !== null &&
                                                              simpleObjectDraver[
                                                                "body"
                                                              ].map((field, fieldIdx) => (
                                                                <React.Fragment key={`field-${index}-${i}-${z}-${fieldIdx}`}>
                                                                  {inputGenerator(
                                                                    field["name"],
                                                                    index,
                                                                    i,
                                                                    DetailKey[
                                                                      field["key"]
                                                                    ],
                                                                    field["type"],
                                                                    z,
                                                                    subs,
                                                                  )}
                                                                </React.Fragment>
                                                              ))}
                                                          </tr>
                                                        );
                                                      },
                                                    )}

                                                  {/* 🔥 BARIS TOTAL UNTUK MEALS */}
                                                  {DetailUnit === "MEALS" &&
                                                    keyName["Detail"]?.length >
                                                      0 && (
                                                      <tr className="bg-gray-100 font-bold">
                                                        <td
                                                          colSpan="6"
                                                          className="text-right px-2 py-2 border-t border-gray-300"
                                                        >
                                                          Total:
                                                        </td>
                                                        <td className="text-right px-2 py-2 border-t border-gray-300">
                                                          {totalMealSummary.toLocaleString(
                                                            "id-ID",
                                                          )}
                                                        </td>
                                                        <td
                                                          colSpan="4"
                                                          className="border-t border-gray-300"
                                                        ></td>
                                                      </tr>
                                                    )}

                                                  {/* 🔥 FOOTER SUMMARY untuk Total Hours (GENERAL_SERVICE - Room, Vehicle, dll) */}
                                                  {(DetailUnit === "ROOM" || DetailUnit === "Vehicle") &&
                                                    keyName["Detail"]?.length > 0 && (
                                                      <tr className="bg-gray-100 font-bold">
                                                        <td
                                                          colSpan="6"
                                                          className="text-right px-2 py-2 border-t border-gray-300 text-sm uppercase"
                                                        >
                                                          Total Hours
                                                        </td>
                                                        <td className="text-right px-2 py-2 border-t border-gray-300 text-blue-700">
                                                          {keyName["Detail"].reduce((sum, item) => {
                                                            if (item.date1 && item.date2) {
                                                              const start = new Date(item.date1).getTime();
                                                              const end = new Date(item.date2).getTime();
                                                              if (end > start) {
                                                                return sum + (end - start) / (1000 * 60 * 60);
                                                              }
                                                            }
                                                            return sum + (Number(item.form4) || 0);
                                                          }, 0).toLocaleString("id-ID", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </td>
                                                        <td
                                                          colSpan="4"
                                                          className="border-t border-gray-300"
                                                        ></td>
                                                      </tr>
                                                    )}
                                                </tbody>
                                              </table>
                                            </div>
                                          </CardBody>
                                        </React.Fragment>
                                      );
                                    }
                                  })
                                );
                              },
                            );
                          } else {
                            const simpleObjectDraver = objectDrawer[Name];
                            if (simpleObjectDraver !== undefined && Detail) {
                              let subs = "2";
                              if (Name === "RENTAL") {
                                subs = "2";
                              } else if (Name === "WASTE_MANAGEMENT_SERVICES") {
                                subs = "3";
                              } else if (Name === "AREA_RENTAL") {
                                subs = "4";
                              } else if (Name === "GENERAL_SERVICE") {
                                subs = "5";
                              } else if (Name === "MANPOWER") {
                                subs = "6";
                              }
                              return (
                                <CardBody key={`${Name}-${index}`} className="w-full mt-5 ">
                                  <label className="block uppercase tracking-wide text-gray-700 text-l font-bold mb-2">
                                    {Name.replace(/[_]/g, " ")}
                                  </label>
                                  <div className="overflow-x-auto">
                                    <hr />
                                    <table className="table-auto w-full bg-transparent border-collapse ">
                                      <thead>
                                        <tr>
                                          {simpleObjectDraver[
                                            "header_upper"
                                          ] !== null &&
                                            simpleObjectDraver[
                                              "header_upper"
                                            ].map((keyName, idx) => (
                                              <th
                                                key={`header-upper-${idx}`}
                                                rowSpan={keyName["rowSpan"]}
                                                colSpan={keyName["colSpan"]}
                                                style={{
                                                  color: Colors.primary,
                                                }}
                                                className="font-bold px-2  align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-center"
                                              >
                                                {keyName["text"]}
                                              </th>
                                            ))}
                                        </tr>
                                        <tr>
                                          {simpleObjectDraver["header"] !==
                                            null &&
                                            simpleObjectDraver["header"].map(
                                              (keyName, idx) => (
                                                <th
                                                  key={`header-${idx}`}
                                                  rowSpan={keyName["rowSpan"]}
                                                  colSpan={keyName["colSpan"]}
                                                  style={{
                                                    color: Colors.primary,
                                                  }}
                                                  className="font-bold px-2  align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-center"
                                                >
                                                  {keyName["text"]}
                                                </th>
                                              ),
                                            )}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {Detail &&
                                          Detail.map((DetailKey, z) => {
                                            return (
                                              <tr key={`detail-${index}-${z}`}>
                                                {simpleObjectDraver["body"] !==
                                                  null &&
                                                  simpleObjectDraver[
                                                    "body"
                                                  ].map((field, fieldIdx) => (
                                                    <React.Fragment key={`field-${index}-${z}-${fieldIdx}`}>
                                                      {inputGenerator(
                                                        field["name"],
                                                        index,
                                                        -1,
                                                        DetailKey[field["key"]],
                                                        field["type"],
                                                        z,
                                                        subs,
                                                      )}
                                                    </React.Fragment>
                                                  ))}
                                              </tr>
                                            );
                                          })}
                                      </tbody>
                                    </table>
                                  </div>
                                </CardBody>
                              );
                            }
                          }
                        }
                      },
                    )}
                </Card>
              </div>
            </div>
            {/*Eqipment*/}
            {/* ────────────────────────────────────────────────────────────── */}
            {/* SUMMARY TOTAL SECTION */}
            {/* ────────────────────────────────────────────────────────────── */}
            <div className="p-4 mt-6">
              <Card className="shadow-lg">
                <CardBody>
                  <label className="block uppercase tracking-wide text-gray-700 text-xl font-bold mb-4">
                    Activity Summary
                  </label>
                  <div className="overflow-x-auto">
                    <table className="table-auto w-full bg-transparent border-collapse">
                      <thead>
                        <tr>
                          <th
                            style={{ color: Colors.primary }}
                            className="font-bold px-4 py-3 text-base whitespace-nowrap text-left border-b-2 border-gray-300 bg-gray-50"
                          >
                            No
                          </th>
                          <th
                            style={{ color: Colors.primary }}
                            className="font-bold px-4 py-3 text-base whitespace-nowrap text-left border-b-2 border-gray-300 bg-gray-50"
                          >
                            Activity Type
                          </th>
                          <th
                            style={{ color: Colors.primary }}
                            className="font-bold px-4 py-3 text-base whitespace-nowrap text-center border-b-2 border-gray-300 bg-gray-50"
                          >
                            Total Items
                          </th>
                          <th
                            style={{ color: Colors.primary }}
                            className="font-bold px-4 py-3 text-base whitespace-nowrap text-center border-b-2 border-gray-300 bg-gray-50"
                          >
                            Total Quantity
                          </th>
                          <th
                            style={{ color: Colors.primary }}
                            className="font-bold px-4 py-3 text-base whitespace-nowrap text-left border-b-2 border-gray-300 bg-gray-50"
                          >
                            Details
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {(() => {
                          let summaryNo = 0;
                          let grandTotalItems = 0;
                          let grandTotalQuantity = 0;
                          const summaryRows = [];

                          values.Activity?.forEach((activity, actIdx) => {
                            const activityName = activity.Name;
                            let totalItems = 0;
                            let totalQuantity = 0;
                            const details = [];

                            if (activityName === "PORT_SERVICES") {
                              activity.DetailActivity?.forEach((subActivity) => {
                                if (!subActivity.Detail || subActivity.Detail.length === 0) return;
                                const subName = subActivity.Name || "Unknown";
                                const itemCount = subActivity.Detail.length;
                                totalItems += itemCount;
                                let subQty = 0;
                                subActivity.Detail.forEach(item => {
                                  subQty += Number(item.form4) || 0;
                                });
                                totalQuantity += subQty;
                                if (itemCount > 0) {
                                  details.push(`${subName}: ${itemCount} items`);
                                }
                              });
                            } else if (activityName === "GENERAL_SERVICE") {
                              activity.DetailActivity?.forEach((subActivity) => {
                                if (!subActivity.Detail || subActivity.Detail.length === 0) return;
                                const subName = subActivity.DetailUnit || subActivity.Name || "Unknown";
                                const itemCount = subActivity.Detail.length;
                                totalItems += itemCount;
                                let subQty = 0;
                                subActivity.Detail.forEach(item => {
                                  subQty += Number(item.form4) || Number(item.form6) || 0;
                                });
                                totalQuantity += subQty;
                                if (itemCount > 0) {
                                  details.push(`${subName}: ${itemCount} items`);
                                }
                              });
                            } else {
                              if (!activity.Detail || activity.Detail.length === 0) return;
                              const itemCount = activity.Detail.length;
                              totalItems = itemCount;
                              activity.Detail.forEach(item => {
                                let qty = 0;
                                if (activityName === "RENTAL") {
                                  qty = Number(item.form6) || 0;
                                } else if (activityName === "AREA_RENTAL") {
                                  qty = Number(item.form2) || 0;
                                } else {
                                  qty = Number(item.form6) || 0;
                                }
                                totalQuantity += qty;
                              });
                            }

                            grandTotalItems += totalItems;
                            grandTotalQuantity += totalQuantity;

                            if (totalItems > 0) {
                              summaryNo++;
                              summaryRows.push(
                                <tr key={`summary-${actIdx}`} className="hover:bg-gray-50">
                                  <td className="px-4 py-3 border-b border-gray-200 text-sm">
                                    {summaryNo}
                                  </td>
                                  <td className="px-4 py-3 border-b border-gray-200 text-sm font-semibold">
                                    {activityName.replace(/[_]/g, " ")}
                                  </td>
                                  <td className="px-4 py-3 border-b border-gray-200 text-sm text-center">
                                    <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full font-semibold">
                                      {totalItems}
                                    </span>
                                  </td>
                                  <td className="px-4 py-3 border-b border-gray-200 text-sm text-center">
                                    <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full font-semibold">
                                      {totalQuantity.toLocaleString("id-ID")}
                                    </span>
                                  </td>
                                  <td className="px-4 py-3 border-b border-gray-200 text-xs text-gray-600">
                                    {details.length > 0 ? details.join(" | ") : "-"}
                                  </td>
                                </tr>
                              );
                            }
                          });

                          return (
                            <>
                              {summaryRows}
                              {summaryRows.length > 0 && (
                                <tr className="bg-gray-200 font-bold">
                                  <td colSpan="2" className="px-4 py-3 text-right text-sm uppercase">
                                    Grand Total
                                  </td>
                                  <td className="px-4 py-3 text-center text-sm">
                                    <span className="bg-blue-600 text-white px-4 py-1 rounded-full">
                                      {grandTotalItems}
                                    </span>
                                  </td>
                                  <td className="px-4 py-3 text-center text-sm">
                                    <span className="bg-green-600 text-white px-4 py-1 rounded-full">
                                      {grandTotalQuantity.toLocaleString("id-ID")}
                                    </span>
                                  </td>
                                  <td className="px-4 py-3 text-xs text-gray-700">
                                    {summaryRows.length} activity type(s)
                                  </td>
                                </tr>
                              )}
                              {summaryRows.length === 0 && (
                                <tr>
                                  <td colSpan="5" className="px-4 py-8 text-center text-gray-500 italic">
                                    No activity data available.
                                  </td>
                                </tr>
                              )}
                            </>
                          );
                        })()}
                      </tbody>
                    </table>
                  </div>
                </CardBody>
              </Card>
            </div>
            {checkedState && (
              <>
                <div className="p-4">
                  <div key={"Act"} className="flex flex-wrap -mx-3 px-3 mb-6 ">
                    <div
                      style={{
                        background: Colors.primary,
                      }}
                      className={`w-full px-4 border border-gray-500 activity rounded  py-3 text-gray-700 hover:bg-light-blue-500 hover:text-white cursor-pointer text-white border-0 rounded-t rounded-b-none`}
                    >
                      Equipment
                    </div>
                    <Card className="flex flex-col items-center content-center rounded-t-none">
                      <CardBody className="w-full pt-0 ">
                        <div className="overflow-x-auto">
                          <table className="table-auto w-full bg-transparent border-collapse">
                            <thead>
                              <tr>
                                <th></th>
                                <th
                                  style={{ color: Colors.primary }}
                                  className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                >
                                  Unit
                                </th>
                                <th
                                  style={{ color: Colors.primary }}
                                  className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                >
                                  Unit Number
                                </th>
                                <th
                                  style={{ color: Colors.primary }}
                                  className="w-1/12 font-bold w-20 px-4 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-center"
                                >
                                  Start Time
                                </th>
                                <th
                                  style={{ color: Colors.primary }}
                                  className="font-bold px-2 w-20  align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-center"
                                >
                                  Finish Time
                                </th>
                                <th
                                  style={{ color: Colors.primary }}
                                  className="font-bold px-2 w-20  align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-center"
                                >
                                  Total Hour
                                </th>
                                <th
                                  style={{ color: Colors.primary }}
                                  className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                >
                                  Hour Meter
                                </th>
                                <th
                                  style={{ color: Colors.primary }}
                                  className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                >
                                  Total Hour Meter
                                </th>
                                <th
                                  style={{ color: Colors.primary }}
                                  className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                >
                                  Remarks
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {values.Equipment &&
                                values.Equipment.map((keyName, i) => (
                                  <tr key={keyName + i}>
                                    <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left"></td>
                                    <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                      <Select
                                        value={selectorEquipment.filter(
                                          ({ value }) =>
                                            value === keyName["Unit"],
                                        )}
                                        isDisabled={true}
                                        menuPortalTarget={document.body}
                                        className=" w-100 "
                                        onChange={(text) => {
                                          let tempdata = JSON.parse(
                                            JSON.stringify(values.Equipment),
                                          );
                                          tempdata[i].Unit = text.value;
                                          editEquipment(tempdata);
                                        }}
                                        options={selectorEquipment}
                                      />
                                    </td>

                                    {/*<th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">*/}

                                    {/*    {<Select*/}
                                    {/*        value={kendaraan.minData.filter(*/}
                                    {/*            ({value}) => value===keyName["Unit"]*/}
                                    {/*        )}*/}
                                    {/*        menuPortalTarget={document.body}*/}
                                    {/*        className=" w-100 "*/}
                                    {/*        isDisabled={true}*/}
                                    {/*        options={kendaraan.minData}*/}
                                    {/*    />}*/}

                                    {/*</th>*/}
                                    <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                      <input
                                        onChange={(text) => {
                                          let tempdata = JSON.parse(
                                            JSON.stringify(values.Equipment),
                                          );
                                          tempdata[i].UnitNumber =
                                            text.target.value;
                                          editEquipment(tempdata);
                                        }}
                                        disabled={true}
                                        value={keyName["UnitNumber"]}
                                        name="Type"
                                        className={
                                          "appearance-none block w-40 text-gray-700 py-2 px-2  border border-gray-200 rounded  leading-tight outline-none bg-white border-gray-500"
                                        }
                                        type="text"
                                      />
                                    </th>
                                    <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                      <DatePicker
                                        showTimeSelectOnly
                                        showTimeInput
                                        showTimeSelect
                                        dateFormat="HH:mm"
                                        timeFormat={"HH:mm"}
                                        disabled={true}
                                        selected={
                                          new Date(
                                            keyName["StartTime"]
                                              ? keyName["StartTime"]
                                              : new Date(),
                                          )
                                        }
                                        className={
                                          "appearance-none block text-center w-40 text-gray-700 py-2 px-2  border border-gray-200 rounded  leading-tight outline-none bg-white border-gray-500"
                                        }
                                        onChange={(time) => {
                                          let tempdata = JSON.parse(
                                            JSON.stringify(values.Equipment),
                                          );
                                          tempdata[i].StartTime = time;
                                          tempdata[i].TotalHour = diff_minutes(
                                            time,
                                            tempdata[i].FinishTime,
                                          );
                                          editEquipment(tempdata);
                                        }}
                                      />
                                    </th>

                                    <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                      <DatePicker
                                        showTimeSelectOnly
                                        showTimeInput
                                        showTimeSelect
                                        dateFormat="HH:mm"
                                        timeFormat={"HH:mm"}
                                        selected={
                                          new Date(
                                            keyName["FinishTime"]
                                              ? keyName["FinishTime"]
                                              : new Date(),
                                          )
                                        }
                                        className={
                                          "appearance-none block text-center w-40 text-gray-700 py-2 px-2  border border-gray-200 rounded  leading-tight outline-none bg-white border-gray-500"
                                        }
                                        onChange={(time) => {
                                          let tempdata = JSON.parse(
                                            JSON.stringify(values.Equipment),
                                          );
                                          tempdata[i].FinishTime = time;
                                          tempdata[i].TotalHour = diff_minutes(
                                            tempdata[i].StartTime,
                                            time,
                                          );
                                          editEquipment(tempdata);
                                        }}
                                      />
                                    </th>
                                    <th className="border-b text-center border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                      {diff_minutes(
                                        keyName.StartTime,
                                        keyName.FinishTime,
                                      )}
                                    </th>
                                    <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                      <input
                                        onChange={(text) => {
                                          let tempdata = JSON.parse(
                                            JSON.stringify(values.Equipment),
                                          );
                                          tempdata[i].HourMeter =
                                            text.target.value;
                                          editEquipment(tempdata);
                                        }}
                                        disabled={true}
                                        value={keyName["HourMeter"]}
                                        name="Type"
                                        className={
                                          "appearance-none block w-40 text-gray-700 py-2 px-2  border border-gray-200 rounded  leading-tight outline-none bg-white border-gray-500"
                                        }
                                        type="text"
                                      />
                                    </th>
                                    <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                      <input
                                        onChange={(text) => {
                                          let tempdata = JSON.parse(
                                            JSON.stringify(values.Equipment),
                                          );
                                          tempdata[i].TotalHourMeter =
                                            text.target.value;
                                          editEquipment(tempdata);
                                        }}
                                        disabled={true}
                                        value={keyName["TotalHourMeter"]}
                                        name="Type"
                                        className={
                                          "appearance-none block w-40 text-gray-700 py-2 px-2  border border-gray-200 rounded  leading-tight outline-none bg-white border-gray-500"
                                        }
                                        type="text"
                                      />
                                    </th>
                                    <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                      <input
                                        onChange={(text) => {
                                          let tempdata = JSON.parse(
                                            JSON.stringify(values.Equipment),
                                          );
                                          tempdata[i].Remarks =
                                            text.target.value;
                                          editEquipment(tempdata);
                                        }}
                                        disabled={true}
                                        value={keyName["Remarks"]}
                                        name="Type"
                                        className={
                                          "appearance-none block w-40 text-gray-700 py-2 px-2  border border-gray-200 rounded  leading-tight outline-none bg-white border-gray-500"
                                        }
                                        type="text"
                                      />
                                    </th>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </CardBody>
                    </Card>
                  </div>
                </div>

                {/*Labour*/}
                <div className="p-4">
                  <div key={"Act"} className="flex flex-wrap -mx-3 px-3 mb-6 ">
                    <div
                      style={{
                        background: Colors.primary,
                      }}
                      className={`w-full px-4 border border-gray-500 activity rounded  py-3 text-gray-700 hover:bg-light-blue-500 hover:text-white cursor-pointer text-white border-0 rounded-t rounded-b-none`}
                    >
                      Labour
                    </div>

                    <Card className="flex flex-col items-center content-center rounded-t-none">
                      <CardBody className="w-full pt-0 ">
                        <div className="overflow-x-auto">
                          <table className="table-auto w-full bg-transparent border-collapse">
                            <thead>
                              <tr>
                                <th></th>
                                <th
                                  style={{ color: Colors.primary }}
                                  className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                >
                                  Labour Description
                                </th>
                                <th
                                  style={{ color: Colors.primary }}
                                  className="w-1/12 font-bold w-20 px-4 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-center"
                                >
                                  Start Time
                                </th>
                                <th
                                  style={{ color: Colors.primary }}
                                  className="font-bold px-2 w-20  align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-center"
                                >
                                  Finish Time
                                </th>
                                <th
                                  style={{ color: Colors.primary }}
                                  className="font-bold px-2 w-20  align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-center"
                                >
                                  Total Hour
                                </th>
                                <th
                                  style={{ color: Colors.primary }}
                                  className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                >
                                  Total Man Power
                                </th>

                                <th
                                  style={{ color: Colors.primary }}
                                  className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                >
                                  Remarks
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {values.Labour &&
                                values.Labour.map((keyName, i) => (
                                  <tr key={keyName + i}>
                                    <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left"></td>
                                    <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                      <Select
                                        value={selectorLabour.filter(
                                          ({ value }) =>
                                            value === keyName["LabourDesc"],
                                        )}
                                        menuPortalTarget={document.body}
                                        className=" w-100 "
                                        isDisabled={true}
                                        onChange={(text) => {
                                          let tempdata = JSON.parse(
                                            JSON.stringify(values.Labour),
                                          );
                                          tempdata[i].LabourDesc = text.value;
                                          editLabour(tempdata);
                                        }}
                                        options={selectorLabour}
                                      />
                                    </td>
                                    {/*<th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">*/}
                                    {/*    {<Select*/}
                                    {/*        value={labour.minData.filter(*/}
                                    {/*            ({value}) => value===keyName["LabourDesc"]*/}
                                    {/*        )}*/}
                                    {/*        menuPortalTarget={document.body}*/}
                                    {/*        className=" w-100 "*/}
                                    {/*        isDisabled={true}*/}
                                    {/*        options={labour.minData}*/}
                                    {/*    />}*/}

                                    {/*</th>*/}
                                    <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                      <DatePicker
                                        showTimeSelectOnly
                                        showTimeInput
                                        dateFormat="HH:mm"
                                        selected={
                                          new Date(
                                            keyName["StartTime"]
                                              ? keyName["StartTime"]
                                              : new Date(),
                                          )
                                        }
                                        className={
                                          "appearance-none block text-center w-40 text-gray-700 py-2 px-2  border border-gray-200 rounded  leading-tight outline-none bg-white border-gray-500"
                                        }
                                        disabled={true}
                                        onChange={(time) => {
                                          let tempdata = JSON.parse(
                                            JSON.stringify(values.Labour),
                                          );
                                          tempdata[i].StartTime = time;
                                          tempdata[i].TotalHour = diff_minutes(
                                            time,
                                            tempdata[i].FinishTime,
                                          );
                                          editLabour(tempdata);
                                        }}
                                      />
                                    </th>

                                    <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                      <DatePicker
                                        showTimeSelectOnly
                                        showTimeInput
                                        dateFormat="HH:mm"
                                        selected={
                                          new Date(
                                            keyName["FinishTime"]
                                              ? keyName["FinishTime"]
                                              : new Date(),
                                          )
                                        }
                                        className={
                                          "appearance-none block text-center w-40 text-gray-700 py-2 px-2  border border-gray-200 rounded  leading-tight outline-none bg-white border-gray-500"
                                        }
                                        disabled={true}
                                        onChange={(time) => {
                                          let tempdata = JSON.parse(
                                            JSON.stringify(values.Labour),
                                          );
                                          tempdata[i].FinishTime = time;
                                          tempdata[i].TotalHour = diff_minutes(
                                            tempdata[i].StartTime,
                                            time,
                                          );
                                          editLabour(tempdata);
                                        }}
                                      />
                                    </th>
                                    <th className="border-b text-center border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                      {keyName["TotalHour"]}
                                    </th>
                                    <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                      <input
                                        onChange={(text) => {
                                          let tempdata = JSON.parse(
                                            JSON.stringify(values.Labour),
                                          );
                                          tempdata[i].TotalManPower =
                                            text.target.value;
                                          editLabour(tempdata);
                                        }}
                                        disabled={true}
                                        value={keyName["TotalManPower"]}
                                        name="Type"
                                        className={
                                          "appearance-none block w-40 text-gray-700 py-2 px-2  border border-gray-200 rounded  leading-tight outline-none bg-white border-gray-500"
                                        }
                                        type="number"
                                      />
                                    </th>
                                    <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                      <input
                                        onChange={(text) => {
                                          let tempdata = JSON.parse(
                                            JSON.stringify(values.Labour),
                                          );
                                          tempdata[i].Remarks =
                                            text.target.value;
                                          editLabour(tempdata);
                                        }}
                                        disabled={true}
                                        value={keyName["Remarks"]}
                                        name="Type"
                                        className={
                                          "appearance-none block w-40 text-gray-700 py-2 px-2  border border-gray-200 rounded  leading-tight outline-none bg-white border-gray-500"
                                        }
                                        type="text"
                                      />
                                    </th>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </CardBody>
                    </Card>
                  </div>
                </div>
                {/*Truck*/}
                <div className="p-4">
                  <div key={"Act"} className="flex flex-wrap -mx-3 px-3 mb-6 ">
                    <div
                      style={{
                        background: Colors.primary,
                      }}
                      className={`w-full px-4 border border-gray-500 activity rounded  py-3 text-gray-700 hover:bg-light-blue-500 hover:text-white cursor-pointer text-white border-0 rounded-t rounded-b-none`}
                    >
                      Trucks Entry
                    </div>

                    <Card className="flex flex-col items-center content-center rounded-t-none">
                      <CardBody className="w-full pt-0 ">
                        <div className="overflow-x-auto">
                          <table className="table-auto w-full bg-transparent border-collapse">
                            <thead>
                              <tr>
                                <th></th>
                                <th
                                  style={{ color: Colors.primary }}
                                  className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                >
                                  Material Desc
                                </th>
                                <th
                                  style={{ color: Colors.primary }}
                                  className="w-1/12 font-bold w-20 px-4 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-center"
                                >
                                  Transporter
                                </th>
                                <th
                                  style={{ color: Colors.primary }}
                                  className="font-bold px-2 w-20  align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-center"
                                >
                                  Unit Number
                                </th>
                                <th
                                  style={{ color: Colors.primary }}
                                  className="font-bold px-2 w-20  align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-center"
                                >
                                  Entry Date
                                </th>
                                <th
                                  style={{ color: Colors.primary }}
                                  className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                >
                                  Exit Date
                                </th>
                                <th
                                  style={{ color: Colors.primary }}
                                  className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                >
                                  Total Hour
                                </th>
                                <th
                                  style={{ color: Colors.primary }}
                                  className="font-bold px-2 align-middle border-b border-solid border-gray-200 text-gray-800 py-3 text-base whitespace-nowrap text-left"
                                >
                                  Remarks
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {values.TrucksEntry &&
                                values.TrucksEntry.map((keyName, i) => (
                                  <tr key={keyName + i}>
                                    <th></th>
                                    <td className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                      <Select
                                        value={selectorTrucks.filter(
                                          ({ value }) =>
                                            value === keyName["MaterialDesc"],
                                        )}
                                        menuPortalTarget={document.body}
                                        className=" w-100 "
                                        onChange={(text) => {
                                          let tempdata = JSON.parse(
                                            JSON.stringify(values.TrucksEntry),
                                          );
                                          tempdata[i].MaterialDesc = text.value;
                                          editTrucksEntry(tempdata);
                                        }}
                                        isDisabled={true}
                                        options={selectorTrucks}
                                      />
                                    </td>
                                    {/*<th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">*/}
                                    {/*    <input*/}
                                    {/*        onChange={(text) => {*/}
                                    {/*            let tempdata = JSON.parse(*/}
                                    {/*                JSON.stringify(values.TrucksEntry)*/}
                                    {/*            );*/}
                                    {/*            tempdata[i].MaterialDesc =*/}
                                    {/*                text.target.value;*/}
                                    {/*            editTrucksEntry(tempdata);*/}
                                    {/*        }}*/}
                                    {/*        disabled={true}*/}
                                    {/*        value={keyName["MaterialDesc"]}*/}
                                    {/*        name="Type"*/}
                                    {/*        className={*/}
                                    {/*            "appearance-none block w-40 text-gray-700 py-2 px-2  border border-gray-200 rounded  leading-tight outline-none bg-white border-gray-500"*/}
                                    {/*        }*/}
                                    {/*        type="text"*/}
                                    {/*    />*/}
                                    {/*</th>*/}

                                    <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                      <input
                                        onChange={(text) => {
                                          let tempdata = JSON.parse(
                                            JSON.stringify(values.TrucksEntry),
                                          );
                                          tempdata[i].Transporter =
                                            text.target.value;
                                          editTrucksEntry(tempdata);
                                        }}
                                        value={keyName["Transporter"]}
                                        name="Type"
                                        disabled={true}
                                        className={
                                          "appearance-none block w-40 text-gray-700 py-2 px-2  border border-gray-200 rounded  leading-tight outline-none bg-white border-gray-500"
                                        }
                                        type="text"
                                      />
                                    </th>

                                    <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                      <input
                                        onChange={(text) => {
                                          let tempdata = JSON.parse(
                                            JSON.stringify(values.TrucksEntry),
                                          );
                                          tempdata[i].UnitNumber =
                                            text.target.value;
                                          editTrucksEntry(tempdata);
                                        }}
                                        value={keyName["UnitNumber"]}
                                        name="Type"
                                        disabled={true}
                                        className={
                                          "appearance-none block w-40 text-gray-700 py-2 px-2  border border-gray-200 rounded  leading-tight outline-none bg-white border-gray-500"
                                        }
                                        type="text"
                                      />
                                    </th>
                                    <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                      <DatePicker
                                        dateFormat="dd/MMMM/yyyy"
                                        selected={
                                          new Date(
                                            keyName["EntryDate"]
                                              ? keyName["EntryDate"]
                                              : new Date(),
                                          )
                                        }
                                        className={
                                          "appearance-none block text-center w-40 text-gray-700 py-2 px-2  border border-gray-200 rounded  leading-tight outline-none bg-white border-gray-500"
                                        }
                                        disabled={true}
                                        onChange={(time) => {
                                          let tempdata = JSON.parse(
                                            JSON.stringify(values.TrucksEntry),
                                          );
                                          tempdata[i].EntryDate = time;
                                          tempdata[i].TotalHour = diff_minutes(
                                            time,
                                            tempdata[i].ExitDate,
                                          );
                                          editTrucksEntry(tempdata);
                                        }}
                                      />
                                    </th>

                                    <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                      <DatePicker
                                        dateFormat="dd/MMMM/yyyy"
                                        selected={
                                          new Date(
                                            keyName["ExitDate"]
                                              ? keyName["ExitDate"]
                                              : new Date(),
                                          )
                                        }
                                        disabled={true}
                                        className={
                                          "appearance-none block text-center w-40 text-gray-700 py-2 px-2  border border-gray-200 rounded  leading-tight outline-none bg-white border-gray-500"
                                        }
                                        onChange={(time) => {
                                          let tempdata = JSON.parse(
                                            JSON.stringify(values.TrucksEntry),
                                          );
                                          tempdata[i].ExitDate = time;
                                          tempdata[i].TotalHour = diff_minutes(
                                            tempdata[i].EntryDate,
                                            time,
                                          );
                                          editTrucksEntry(tempdata);
                                        }}
                                      />
                                    </th>
                                    <th className="border-b text-center border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                      {diff_minutes(
                                        keyName["EntryDate"],
                                        keyName["ExitDate"],
                                      )}
                                    </th>
                                    <th className="border-b border-gray-200 align-middle font-light text-sm whitespace-nowrap px-2 py-1 text-left">
                                      <input
                                        onChange={(text) => {
                                          let tempdata = JSON.parse(
                                            JSON.stringify(values.TrucksEntry),
                                          );
                                          tempdata[i].Remarks =
                                            text.target.value;
                                          editTrucksEntry(tempdata);
                                        }}
                                        disabled={true}
                                        value={keyName["Remarks"]}
                                        name="Type"
                                        className={
                                          "appearance-none block w-40 text-gray-700 py-2 px-2  border border-gray-200 rounded  leading-tight outline-none bg-white border-gray-500"
                                        }
                                        type="text"
                                      />
                                    </th>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </CardBody>
                    </Card>
                  </div>
                </div>
                <Modal
                  active={modalShippingManifest}
                  toggler={() => {
                    setModalShippingManifest((prev) => !prev);
                  }}
                >
                  <ModalHeader
                    className="mt-20"
                    toggler={() => {
                      setModalShippingManifest(false);
                    }}
                  >
                    Shipping Manifest
                  </ModalHeader>
                  <ModalBody>
                    {values.ShippingManifestDetail && (
                      <div className="p-4">
                        <div className="flex flex-wrap -mx-3 mb-6">
                          <div className="w-1/2 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-light-green-700 text-xs font-bold mb-2 ">
                              Vessel Name *
                            </label>
                            <input
                              disabled={true}
                              value={
                                values["ShippingManifestDetail"].VesselName
                              }
                              name="VesselName"
                              className={
                                (values["ShippingManifestDetail"].VesselName ||
                                  buttonTouched) &&
                                errors.ShippingManifest
                                  ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                  : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                              }
                              type="text"
                            />
                          </div>
                        </div>
                        <div className="flex flex-wrap -mx-3 mb-6">
                          <div className="w-1/2 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-light-green-700 text-xs font-bold mb-2 ">
                              Master Name *
                            </label>
                            <input
                              value={
                                values["ShippingManifestDetail"].MasterName
                              }
                              disabled={true}
                              name="MasterName"
                              className={
                                (values["ShippingManifestDetail"].MasterName ||
                                  buttonTouched) &&
                                errors.ShippingManifest
                                  ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                  : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                              }
                              type="text"
                            />
                          </div>
                        </div>
                        <div className="flex flex-wrap -mx-3 mb-6">
                          <div className="w-1/2 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-light-green-700 text-xs font-bold mb-2 ">
                              Owner Vessel *
                            </label>
                            <input
                              disabled={true}
                              value={
                                values["ShippingManifestDetail"].OwnerVessel
                              }
                              name="OwnerVessel"
                              className={
                                (values["ShippingManifestDetail"].OwnerVessel ||
                                  buttonTouched) &&
                                errors.ShippingManifest
                                  ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                  : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                              }
                              type="text"
                            />
                          </div>
                        </div>
                        <div className="flex flex-wrap -mx-3 mb-6">
                          <div className="w-1/2 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-light-green-700 text-xs font-bold mb-2 ">
                              Ship Agent
                            </label>
                            <input
                              disabled={true}
                              value={values["ShippingManifestDetail"].ShipAgent}
                              name="ShipAgent"
                              className={
                                (values["ShippingManifestDetail"].ShipAgent ||
                                  buttonTouched) &&
                                errors.ShippingManifest
                                  ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                  : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                              }
                              type="text"
                            />
                          </div>
                        </div>
                        <div className="flex flex-wrap -mx-3 mb-6">
                          <div className="w-1/2 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-light-green-700 text-xs font-bold mb-2 ">
                              Flag *
                            </label>
                            <input
                              disabled={true}
                              value={values["ShippingManifestDetail"].Flag}
                              name="Flag"
                              className={
                                (values["ShippingManifestDetail"].Flag ||
                                  buttonTouched) &&
                                errors.ShippingManifest
                                  ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                  : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                              }
                              type="text"
                            />
                          </div>
                          <div className="w-1/2 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-light-green-700 text-xs font-bold mb-2 ">
                              Port Registry *
                            </label>
                            <input
                              disabled={true}
                              value={
                                values["ShippingManifestDetail"].PortRegistry
                              }
                              name="PortRegistry"
                              className={
                                (values["ShippingManifestDetail"]
                                  .PortRegistry ||
                                  buttonTouched) &&
                                errors.ShippingManifest
                                  ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                  : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                              }
                              type="text"
                            />
                          </div>
                        </div>
                        <div className="flex flex-wrap -mx-3 mb-6">
                          <div className="w-1/2 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-light-green-700 text-xs font-bold mb-2 ">
                              Port Depature *
                            </label>
                            <input
                              disabled={true}
                              value={
                                values["ShippingManifestDetail"].PortDepature
                              }
                              name="PortDepature"
                              className={
                                (values["ShippingManifestDetail"]
                                  .PortDepature ||
                                  buttonTouched) &&
                                errors.ShippingManifest
                                  ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                  : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                              }
                              type="text"
                            />
                          </div>
                          <div className="w-1/2 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-light-green-700 text-xs font-bold mb-2 ">
                              ETA *
                            </label>
                            <DatePicker
                              showTimeInput
                              dateFormat="dd-MM-yyyy HH:mm"
                              selected={
                                new Date(
                                  values["ShippingManifestDetail"].Eta
                                    ? values["ShippingManifestDetail"].Eta
                                    : new Date(),
                                )
                              }
                              disabled={true}
                              className={
                                (values["ShippingManifestDetail"].Eta ||
                                  buttonTouched) &&
                                errors.ShippingManifest
                                  ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                  : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                              }
                            />
                          </div>
                        </div>
                        <div className="flex flex-wrap -mx-3 mb-6">
                          <div className="w-1/2 px-3 mb-6 md:mb-0">
                            <label className="block uppercase tracking-wide text-light-green-700 text-xs font-bold mb-2 ">
                              Quantity *
                            </label>
                            <input
                              value={values["ShippingManifestDetail"].Quantity}
                              disabled={true}
                              name="Quantity"
                              className={
                                (values["ShippingManifestDetail"].Quantity ||
                                  buttonTouched) &&
                                errors.ShippingManifest
                                  ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                                  : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
                              }
                              type="text"
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      color="green"
                      buttonType="link"
                      onClick={() => {
                        setModalShippingManifest(false);
                      }}
                      ripple="green"
                    >
                      Close
                    </Button>
                  </ModalFooter>
                </Modal>
              </>
            )}
          </div>
        </div>
      </>
    );
  }
};

export default OperationalOutputDetail;
